import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { FormControl, FormLabel, RadioGroup } from "@mui/material";

const UIRadioButton = ({
  label,
  name,
  id = "",
  value = "",
  checked,
  intermediate,
  handleChange,
  labelPlacement = "end",
  size = "small",
  parentStyle = {},
  style = {},
  disabled = false,
}) => {
  return (
    <FormControlLabel
      disabled={disabled}
      sx={{
        ml: "0px",
        mr: "2px",
        ...parentStyle,
        fontSize: "5px",

        "& .Mui-checked": {
          color: "var(--palette-secondary_button_text) !important",
        },
        "& .Mui-disabled": {
          color: "var(--palette-disabled_button_text) !important",
        },
        "& .MuiRadio-root": {
          color: "var(--palette-text)",
        },
      }}
      control={
        <Radio
          name={name}
          checked={checked}
          onChange={handleChange}
          sx={{ p: "5px", mr: 1, ...style }}
          size={size}
          id={id}
          value={value}
        />
      }
      label={label}
      labelPlacement={labelPlacement}
    />
  );
};

export default UIRadioButton;

export const UIRadioGroup = ({
  title = "Label",
  name = "radio",
  onChange = () => {},
  options = [],
  value = "",
  size = "medium",
}) => {
  return (
    <FormControl>
      <FormLabel id="demo-radio-buttons-group-label">{title}</FormLabel>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        value={value}
        name={name}
        onChange={onChange}
      >
        {options.map((op, index) => (
          <FormControlLabel
            key={index}
            value={op.value}
            control={<Radio size={size} sx={{ p: 0.8 }} />}
            label={op.label}
            sx={{
              "& .Mui-checked": {
                color: "var(--palette-secondary_button_text) !important",
              },
              "& .MuiRadio-root": {
                color: "var(--palette-text)",
              },
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
